import { WarningIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Warning = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <WarningIcon size={Sizes[size]} color={fill} {...rest} />;
};

Warning.displayName = 'Warning';
